import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CourtPanelAssignmentComponent } from './dashboard/court-panel-assignment/court-panel-assignment.component';
import { HearingScheduleComponent } from './dashboard/hearing-schedule/hearing-schedule.component';
import { MyAssignmentsComponent } from './dashboard/my-assignments/my-assignments.component';
import { HearingProcessComponent } from './dashboard/hearing-process/hearing-process.component';
import { CaseSheetComponent } from './dashboard/case-sheet/case-sheet.component';
import { LoginComponent } from './login/login.component';
import { canActivateChildGuardFn } from './auth-guard.service';
import { HomeComponent } from './dashboard/home/home.component';
import { AuthCheckComponent } from './auth-check/auth-check.component';
import { CalenderDetailsComponent } from './dashboard/calender-details/calender-details.component';
import { DocumentReceptionComponent } from './dashboard/document-reception/document-reception.component';
import { FeeAssessmentComponent } from './dashboard/fee-assessment/fee-assessment.component';
import { AppComponent } from './app.component';
import { HearingNoticeComponent } from './dashboard/hearing-notice/hearing-notice.component';
import { RecordFeePaymentComponent } from './dashboard/record-fee-payment/record-fee-payment.component';
import { ResetPasswordComponent } from './login/reset-password/reset-password.component';
import { ForgotPasswordComponent } from './dashboard/forgot-password/forgot-password.component';
import { PartiesComponent } from './dashboard/parties/parties.component';
import { ListOfFilesComponent } from './dashboard/list-of-files/list-of-files.component';
import { CloseTaskComponent } from './dashboard/close-task/close-task.component';
import { SubmenuAccordionComponent } from './dashboard/submenu-accordion/submenu-accordion.component';
import { ReportsComponent } from './dashboard/reports/reports.component';
import { CaseScreenComponent } from './dashboard/case-screen/case-screen.component';
import { CourtStaffRolesComponent } from './dashboard/court-staff-roles/court-staff-roles.component';
import { JudgePanelAssignmentComponent } from './dashboard/judge-panel-assignment/judge-panel-assignment.component';
import { StaffCourtAssignmentComponent } from './dashboard/staff-court-assignment/staff-court-assignment.component';
import { ConfigurableSearchTableComponent } from './dashboard/configurable-search-table/configurable-search-table.component';
import { ConfigurableMasterDetailTableComponent } from './dashboard/configurable-master-detail-table/configurable-master-detail-table.component';
import { RoleMenuMappingComponent } from './dashboard/role-menu-mapping/role-menu-mapping.component';
import { ResetPasswordComponentScreen } from './dashboard/reset-password-screen/reset-password-screen.component';
import { ForceLogoff } from './dashboard/force-logoff/force-logoff.component';
import { SessionDetailsComponent } from './dashboard/session-details/session-details.component';
import { JudgementDateComponent } from './dashboard/judgement-date/judgement-date.component';
import { PanelReAssignmentComponent } from './dashboard/panel-reAssignment/panel-re-assignment.component';

export const routes: Routes = [
  { path: 'auth-check', component: AuthCheckComponent }, // Ensure this matches your URL
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  {
    path: 'dashboard', component: DashboardComponent, canActivateChild: [canActivateChildGuardFn],
    children: [
      { path: '', component: AppComponent, pathMatch: 'full' },
      { path: 'court-panel-assignment', component: CourtPanelAssignmentComponent },
      { path: 'hearing-schedule', component: HearingScheduleComponent },
      { path: 'reports/action-status-on-cases', component: ReportsComponent },
      { path: 'reports/action-status-on-appeals', component: ReportsComponent },
      { path: 'reports/case-duration', component: ReportsComponent },
      { path: 'reports/case-hearing-schedule', component: ReportsComponent },
      { path: 'reports/appeal-hearing-schedule', component: ReportsComponent },
      { path: 'reports/case-statistics', component: ReportsComponent },
      { path: 'reports/appeal-statistics', component: ReportsComponent },
      { path: 'reports/case-history', component: ReportsComponent },
      { path: 'reports/appeal-history', component: ReportsComponent },
      { path: 'reports/case-history-for-counsel', component: ReportsComponent },
      { path: 'reports/appeal-history-for-counsel', component: ReportsComponent },
      { path: 'reports/current-phase-of-cases', component: ReportsComponent },
      { path: 'reports/current-phase-of-appeals', component: ReportsComponent },
      { path: 'reports/case-progress', component: ReportsComponent },
      { path: 'reports/cases-pending-for-hearing', component: ReportsComponent },
      { path: 'reports/appeals-pending-for-hearing', component: ReportsComponent },
      { path: 'reports/causelist', component: ReportsComponent },
      { path: 'reports/date-alert-by-last-document-recorded', component: ReportsComponent },
      { path: 'reports/pending-tasks-till-date', component: ReportsComponent },
      { path: 'reports/documents-received-for-case', component: ReportsComponent },
      { path: 'reports/documents-received-for-appeal', component: ReportsComponent },
      { path: 'reports/judge-panel-for-appeals', component: ReportsComponent },
      { path: 'reports/list-of-cases-by-judge', component: ReportsComponent },
      { path: 'reports/list-of-appeals-by-justice', component: ReportsComponent },
      { path: 'reports/list-of-cases-handled-by-judge', component: ReportsComponent },
      { path: 'reports/list-of-appeals-handled-by-justice', component: ReportsComponent },
      { path: 'reports/list-of-cases-received', component: ReportsComponent },
      { path: 'reports/list-of-appeals-received', component: ReportsComponent },
      { path: 'reports/list-of-judges-that-handled-case', component: ReportsComponent },
      { path: 'reports/list-of-justices-that-handled-appeal', component: ReportsComponent },
      { path: 'reports/list-of-motions-filed-in-case', component: ReportsComponent },
      { path: 'reports/staff-assignment-history', component: ReportsComponent },
      { path: 'reports/list-of-users-and-roles', component: ReportsComponent },
      { path: 'reports/list-of-backlog-cases', component: ReportsComponent },
      { path: 'reports/list-of-backlog-appeals', component: ReportsComponent },
      { path: 'reports/list-of-appeals-by-status', component: ReportsComponent },
      { path: 'reports/audit-trail', component: ReportsComponent },
      { path: 'reports/pending-case-statistics', component: ReportsComponent },
      { path: 'reports/appeal-statistics-reports', component: ReportsComponent },
      { path: 'reports/case-assignment-statistics', component: ReportsComponent },
      { path: 'reports/appeal-summary-based-on-appeal-type', component: ReportsComponent },
      { path: 'reports/appeals-by-lower-court', component: ReportsComponent },
      { path: 'reports/appeals-by-party-name', component: ReportsComponent },
      { path: 'reports/appeal-details-based-on-party-name', component: ReportsComponent },
      { path: 'my-assignments', component: MyAssignmentsComponent },
      { path: 'hearing-process', component: HearingProcessComponent },
      { path: 'case-sheet', component: CaseSheetComponent },
      { path: 'calender-details', component: CalenderDetailsComponent },
      { path: 'documents-reception', component: DocumentReceptionComponent },
      { path: 'record-fee-payment', component: RecordFeePaymentComponent },
      { path: 'fee-assessment', component: FeeAssessmentComponent },
      { path: 'hearing-notice', component: HearingNoticeComponent },
      { path: 'fee-payment', component: RecordFeePaymentComponent },
      { path: 'reset-password', component: ResetPasswordComponent },
      { path: 'parties', component: PartiesComponent },
      { path: 'list-of-files', component: ListOfFilesComponent },
      { path: 'close-task', component: CloseTaskComponent },
      { path: 'monitoring', component: SubmenuAccordionComponent },
      { path: 'court/court-staff-registration', component: PartiesComponent },
      { path: 'court/court-staff-roles', component: CourtStaffRolesComponent },
      { path: 'court/judge-panel-assignment', component: JudgePanelAssignmentComponent },
      { path: 'court/justice-panel-assignment', component: JudgePanelAssignmentComponent },
      { path: 'court/staff-court-assignment', component: StaffCourtAssignmentComponent },
      { path: 'masters/administrative-unit-types', component: ConfigurableSearchTableComponent },
      { path: 'masters/absence-types', component: ConfigurableSearchTableComponent },
      { path: 'masters/session-master', component: ConfigurableSearchTableComponent },
      { path: 'masters/lower-courts', component: ConfigurableSearchTableComponent },
      { path: 'masters/id-structure-types', component: ConfigurableSearchTableComponent },
      { path: 'masters/event-types', component: ConfigurableSearchTableComponent },
      { path: 'masters/task-types', component: ConfigurableSearchTableComponent },
      { path: 'masters/fee-component-types', component: ConfigurableSearchTableComponent },
      { path: 'masters/party-types', component: ConfigurableSearchTableComponent },
      { path: 'masters/contact-types', component: ConfigurableSearchTableComponent },
      { path: 'masters/receipt-types', component: ConfigurableSearchTableComponent },
      { path: 'masters/document-directions', component: ConfigurableSearchTableComponent },
      { path: 'masters/case-status', component: ConfigurableSearchTableComponent },
      { path: 'masters/appeal-status', component: ConfigurableSearchTableComponent },
      { path: 'admin/news-and-events', component: ConfigurableSearchTableComponent },
      { path: 'admin/holidays', component: ConfigurableSearchTableComponent },
      { path: 'masters/court-divisions-case-types', component: ConfigurableMasterDetailTableComponent },
      { path: 'masters/court-divisions-appeal-types', component: ConfigurableMasterDetailTableComponent },
      { path: 'masters/document-types-event-types', component: ConfigurableMasterDetailTableComponent },
      { path: 'masters/case-types-document-types', component: ConfigurableMasterDetailTableComponent },
      { path: 'masters/appeal-types-document-types', component: ConfigurableMasterDetailTableComponent },
      { path: 'masters/event-types-task-types-roles', component: ConfigurableMasterDetailTableComponent },
      { path: 'masters/document-types-case-phase-types', component: ConfigurableMasterDetailTableComponent },
      { path: 'masters/document-types-appeal-phase-types', component: ConfigurableMasterDetailTableComponent },
      { path: 'masters/staff-roles-document-types', component: ConfigurableMasterDetailTableComponent },
      { path: 'masters/party-roles-document-types', component: ConfigurableMasterDetailTableComponent },
      { path: 'masters/administrative-units', component: ConfigurableSearchTableComponent },
      { path: 'masters/party-roles', component: ConfigurableSearchTableComponent },
      { path: 'masters/case-types', component: ConfigurableSearchTableComponent },
      { path: 'masters/appeal-types', component: ConfigurableSearchTableComponent },
      { path: 'masters/court-divisions', component: ConfigurableMasterDetailTableComponent },
      { path: 'masters/case-status-case-phase-types', component: ConfigurableMasterDetailTableComponent },
      { path: 'masters/appeal-status-appeal-phase-types', component: ConfigurableMasterDetailTableComponent },
      { path: 'masters/task-types-event-types', component: ConfigurableMasterDetailTableComponent },
      { path: 'masters/payment-types', component: ConfigurableSearchTableComponent },
      { path: 'court-properties', component: ConfigurableSearchTableComponent },
      { path: 'masters/fee-component-types', component: ConfigurableSearchTableComponent },
      { path: 'admin/role-menu-mapping', component: RoleMenuMappingComponent },
      { path: 'masters/case-phase-types', component: ConfigurableSearchTableComponent },
      { path: 'masters/appeal-phase-types', component: ConfigurableSearchTableComponent },
      { path: 'record-fee-payment', component: RecordFeePaymentComponent },
      { path: 'reset-password', component: ResetPasswordComponent },
      { path: 'masters/document-types', component: ConfigurableSearchTableComponent },
      { path: 'admin/reset-password', component: ResetPasswordComponentScreen },
      { path: 'admin/force-log-off', component: ForceLogoff },
      { path: 'masters/staff-types', component: ConfigurableSearchTableComponent },
      { path: 'masters/judge-panel', component: ConfigurableSearchTableComponent },
      { path: 'masters/justice-panel', component: ConfigurableSearchTableComponent },
      { path: 'court/session-details', component: SessionDetailsComponent },
      { path: 'judgement-schedule', component: JudgementDateComponent },
      { path: 'justice-reassignment', component: PanelReAssignmentComponent },
      { path: 'judge-reassignment', component: PanelReAssignmentComponent },


      //{ path: 'home', component: HomeComponent },


    ]
  }
];
